import { db } from "../firebaseClient"
import { collection, getDocs } from "firebase/firestore"

// Platform-wide People list — Control Plane only. Firestore rules allow this
// query because isPlatformAdmin() is evaluated per returned doc and holds
// true uniformly for the caller, so no extra index or per-doc field is
// needed (unlike org-scoped queries elsewhere that filter on orgId).
export const listAllUsers = async () => {
  try {
    const usersRef = collection(db, "users")
    const snap = await getDocs(usersRef)
    const users = snap.docs?.map((d) => ({ uid: d.id, ...d.data() }))
    return { users, error: null }
  } catch (error) {
    return { users: [], error }
  }
}